import React from 'react'
import { useTranslation } from 'react-i18next'
import { WithTooltip } from '../../../ui/tooltip'
import { HamburgerIcon } from '../icons/HamburgerIcon'
import { SidebarLeftIcon } from '../icons/SidebarLeftIcon'
import { SidebarLeftCollapsedIcon } from '../icons/SidebarLeftCollapsedIcon'

const ICON_SIZE = 16

export interface SidebarToggleProps {
  variant: 'hamburger' | 'sidebar-icon'
  isOpen: boolean
  onClick: () => void
  label: string
  /** Hover-peek: slides the navigation in as an overlay. See TitlebarContext. */
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export const SidebarToggle = React.memo(({ variant, isOpen, onClick, label, onMouseEnter, onMouseLeave }: SidebarToggleProps) => {
  const { t } = useTranslation()
  // Wie der Menüeintrag Darstellung › Seitenleiste: nennt, was ein Klick tut, samt ⌘B.
  return (
    <WithTooltip
      content={t(isOpen ? 'titlebar.hideSidebar' : 'titlebar.showSidebar')}
      shortcut={{ kind: 'character', text: 'B', mod: true }}
      side="bottom"
    >
      <button
        className={`titlebar__sidebar-toggle titlebar__sidebar-toggle--${variant}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        aria-label={label}
      >
        {variant === 'hamburger'
          ? <HamburgerIcon size={ICON_SIZE} />
          : isOpen ? <SidebarLeftIcon size={ICON_SIZE} /> : <SidebarLeftCollapsedIcon size={ICON_SIZE} />
        }
      </button>
    </WithTooltip>
  )
})
